import { Component, OnInit } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-arrow-left',
  templateUrl: './arrow-left.component.html',
})
export class ArrowLeftComponent extends Icon {
}
